var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_vm._m(0),_c('div',{staticClass:"page-container__body"},[_c('CardPassword'),_c('CardProfile'),_c('CardImageAndVideo'),_c('CardTitleAndBasePrice'),_c('CardDescription'),_c('CardTimetable',{ref:"timetable"})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container__header"},[_c('h1',{staticClass:"header-1 page-container__title"},[_vm._v("Setări")])])
}]

export { render, staticRenderFns }